import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import AppIcon from './icons/AppIcon';
import { useAuth } from '../hooks/useAuth';
import { getPrimaryNavItems } from '../navigation/appNavigation';
import { hasScope } from '../permissions/scopePermissions';

/**
 * The mobile tab bar (<768px), role-aware (Rule 56).
 *
 * A member's day is Benefits / Billing / Network / Claims; an admin's is the
 * verification queue. `getPrimaryNavItems` picks the four that matter for who
 * is signed in — showing an admin "My Benefits" or a member "Members" would
 * waste the only four slots a thumb can reach. Everything else stays in the
 * off-canvas drawer.
 *
 * Hidden on desktop and when printing.
 */
export default function BottomNav() {
  const { t } = useTranslation();
  const { user } = useAuth();

  const scopes = Array.isArray(user?.scopes) ? user.scopes : [];
  const items = getPrimaryNavItems((scope) => hasScope(scopes, scope));

  if (items.length === 0) return null;

  return (
    <nav className="bottomnav rmc2-no-print" aria-label={t('shell.primaryNav')}>
      {items.map((item) => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) => `bottomnav-item ${isActive ? 'is-active' : ''}`}
        >
          <AppIcon name={item.iconKey} size={22} />
          <span className="bottomnav-label">{t(item.labelKey ?? '', item.label)}</span>
        </NavLink>
      ))}
    </nav>
  );
}
